import React, { useState } from 'react'
 
 
import FieldOfficerTransferList from './FieldOfficerTransferList';
import FieldOfficerTransferForm from './FieldOfficerTransferForm';

const FieldOfficerTransfer= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <FieldOfficerTransferForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <FieldOfficerTransferList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default FieldOfficerTransfer